import React from 'react'
import { node, number } from 'prop-types'
import styled, { css } from 'styled-components'

import { mediaDown } from 'styles/media'
import * as spacing from 'styles/spacing'

const Container = styled.div`
  position: static;

  ${props =>
    props.row >= 4 &&
    css`
      ${mediaDown.medium`
      margin-left: -${spacing.large};
      margin-right: -${spacing.large};
      padding-left: ${spacing.large};
      padding-right: ${spacing.large};
      padding-bottom: ${spacing.small};
      margin-bottom: -${spacing.small};
      margin-top: -${spacing.medium};
      padding-top: ${spacing.medium};
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    `};
    `}
`

const Scroll = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -${spacing.small};

  ${props =>
    props.row >= 4 &&
    css`
      ${mediaDown.medium`
      position: relative;
      flex-wrap: nowrap;
      justify-content: flex-start;
    `};
    `}
`

const Item = styled.div`
  display: flex;
  padding: ${spacing.small};
  flex-shrink: 0;
  width: calc(100% / ${props => props.row});

  ${props =>
    props.row >= 4 &&
    css`
      ${mediaDown.medium`
      width: 130px;
      position: relative;

      &:after {
        content: "";
        display: block;
        position: absolute;
        right: -${spacing.medium};
        width: ${spacing.medium};
        height: 1px;
      }
    `};
    `}
`

const List = ({ children, row }) => (
  <Container row={row}>
    <Scroll row={row}>
      {React.Children.map(children, (child, i) => {
        if (child) {
          return (
            <Item key={i} row={row}>
              {child}
            </Item>
          )
        }
      })}
    </Scroll>
  </Container>
)

List.propTypes = {
  children: node.isRequired,
  row: number.isRequired
}

export default List
